export const ALERTS_UPDATE_SYSTEM_ALERT = 'alerts/ALERTS_UPDATE_SYSTEM_ALERT';
export const ALERTS_UPDATE_SYSTEM_ALERT_RESULT = 'alerts/ALERTS_UPDATE_SYSTEM_ALERT_RESULT';
export const ALERTS_CREATE_SYSTEM_ALERT = 'alerts/ALERTS_CREATE_SYSTEM_ALERT';
export const ALERTS_CREATE_SYSTEM_ALERT_RESULT = 'alerts/ALERTS_CREATE_SYSTEM_ALERT_RESULT';
